var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasError)?_c('div',{staticClass:"banner-wrapper"},[_vm._t("default")],2):_c('h1',{staticClass:"error--text ma-4"},[_vm._v(" Что-то пошло не так. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }